import { LocalAdventure } from "../../../entities/adventures/Adventure";
import { AdventureState } from "./AdventureStore.State"


const getAdventure = (state: AdventureState, adventureId: string) => {
    const adventure = state.adventures.find(a => a.id == adventureId);
    if (adventure == null) {
        console.error('Attempted to perform unknown operation on unknown character.');
    }
    return adventure;
}

const updateAdventure = (state: AdventureState, newAdventure: LocalAdventure): AdventureState => {
    const newState = ({
        ...state,
        adventures: [...state.adventures.filter(a => a.id != newAdventure.id), newAdventure]
    });
    return newState;
}

export const AdventureReducerHelpers = Object.freeze({
    getAdventure,
    updateAdventure,
})